import { jsxs, jsx } from 'react/jsx-runtime';
import ContentLoader from 'react-content-loader';

function DashboardLoader(props) {
  return jsxs(ContentLoader, {
    height: "230",
    viewBox: "0 0 265 230",
    className: "w-full",
    ...props,
    children: [jsx("rect", {
      x: "15",
      y: "15",
      rx: "4",
      ry: "4",
      width: "200",
      height: "25"
    }), jsx("rect", {
      x: "15",
      y: "50",
      rx: "2",
      ry: "2",
      width: "40",
      height: "15"
    }), jsx("rect", {
      x: "75",
      y: "45",
      rx: "16",
      ry: "16",
      width: "55",
      height: "22"
    }), jsx("rect", {
      x: "15",
      y: "75",
      rx: "3",
      ry: "3",
      width: "215",
      height: "15"
    }), jsx("rect", {
      x: "15",
      y: "105",
      rx: "3",
      ry: "3",
      width: "50",
      height: "15"
    }), jsx("rect", {
      x: "75",
      y: "105",
      rx: "3",
      ry: "3",
      width: "50",
      height: "15"
    }), jsx("rect", {
      x: "135",
      y: "105",
      rx: "3",
      ry: "3",
      width: "50",
      height: "15"
    }), jsx("rect", {
      x: "15",
      y: "135",
      rx: "16",
      ry: "16",
      width: "55",
      height: "22"
    }), jsx("rect", {
      x: "15",
      y: "165",
      rx: "2",
      ry: "2",
      width: "150",
      height: "50"
    }), jsx("rect", {
      x: "215",
      y: "180",
      rx: "2",
      ry: "2",
      width: "40",
      height: "20"
    })]
  });
}

export { DashboardLoader };
